import backend from "../api/api";
import history from "../history";
import { store } from "../store";
import { message } from "antd";

const getConfig = () => {
    const token = store.getState().auth.token;

    const config = {
        headers: {
            Authorization: `Token ${token}`,
        },
    };

    return config;
};

export const createInvoicePayment = (formValues) => async (dispatch) => {
    try {
        const response = await backend.post(
            "api/order/invoicepayment/",
            { ...formValues },
            getConfig()
        );
        if (response.status === 201) {
            return response.data;
        }
    } catch (error) {
        alert(error);
    }
};

export const getAllInvoicePayment = () => async (dispatch) => {
    try {
        const response = await backend.get("api/order/invoicepayment/", getConfig());
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.log(error);
    }
};

export const deleteInvoicePayment = (id) => async (dispatch) => {
    try {
        const response = await backend.delete(
            `api/order/invoicepayment/${id}/`,
            getConfig()
        );
        message.success("Sccessfully Removed");
        history.push("/cupons");
    } catch (error) {
        console.log(error);
    }
};

export const updateInvoicePayment = (id, formValues) => async (dispatch) => {
    formValues["data"] = "";
    try {
        const response = await backend.patch(
            `api/order/invoicepayment/${id}/`,
            formValues,
            getConfig()
        );
        return response.data;
    } catch (error) {
        console.log(error.response);
    }
};

export const getInvoicePaymentSearchResult = (start = "", end = "", paid_by = "",invoice__location="") => async (dispatch) => {
    try {
        const response = await backend.get(
            `api/order/invoicepayment/?start=${start}&end=${end}&paid_by=${paid_by}&invoice__location=${invoice__location}`,
            getConfig()
        );

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        alert(error);
    }
};


export const getInvoicePaymentSearchResultWithPagination = (start = "", end = "", paid_by = "", invoice__location="") => async (dispatch) => {
    try {
        const response = await backend.get(
            `api/order/invoicepaymentP/?start=${start}&end=${end}&paid_by=${paid_by}&invoice__location=${invoice__location}`,
            getConfig()
        );

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        alert(error);
    }
};
